module.exports = {"TXTCLI_Each_ticket_set_consists_of_th_ELL":{"id":"TXTCLI_Each_ticket_set_consists_of_th_ELL","defaultMessage":"各チケット セットは次のチケットが含まれます。"}}